import { useState, useCallback } from "react";
import { loadFromStorage, saveToStorage } from "@/lib/storage";

export function usePersistedState<T>(
  key: string,
  defaultValue: T
): [T, (value: T | ((prev: T) => T)) => void] {
  const [state, setState] = useState<T>(
    () => loadFromStorage<T>(key) ?? defaultValue
  );

  const setPersistedState = useCallback(
    (value: T | ((prev: T) => T)) => {
      setState((prev) => {
        const next = value instanceof Function ? value(prev) : value;
        saveToStorage(key, next);
        return next;
      });
    },
    [key]
  );

  return [state, setPersistedState];
}
